




























































import {
  PaginaRevista,
  ProdutoPaginaRevista,
  Revista,
  RevistasService,
} from "@/services/revistas.service";
import { Component, Watch } from "vue-property-decorator";
import { Debounce } from "vue-debounce-decorator";
import Loading from "@/shared/components/loading.vue";
import DataTable from "@/shared/components/data-table.vue";
import Tooltip from "@/shared/components/tooltip.vue";
import Confirm from "@/shared/components/confirm.vue";
import AdicionarProdutoPaginaRevista from "./AdicionarProdutoPaginaRevista.vue";
import EditarProdutoPaginaRevista from "./EditarProdutoPaginaRevista.vue";
import { moeda } from "@/shared/filters";
import CardRevista from "../CardRevista.vue";
import GlobalMixin from "@/shared/mixins/globalMixin";
import { mixins } from "vue-class-component";
@Component({
  components: {
    Loading,
    DataTable,
    Tooltip,
    AdicionarProdutoPaginaRevista,
    EditarProdutoPaginaRevista,
    CardRevista,
    Confirm,
  },
  filters: {
    moeda,
  },
})
export default class ProdutosPaginasRevista extends mixins(GlobalMixin) {
  revista = {} as Revista;
  paginas = [] as PaginaRevista[];
  pagina = {} as PaginaRevista;
  paginaAtual = 1;
  loading = false;
  headers = [
    { value: "imagemCompleta", text: "Imagem" },
    { value: "descricao", text: "Produto" },
    { value: "valor", text: "Valor" },
    { value: "valorPromocional", text: "Valor Promocional" },
    { value: "actions", text: "Ações", sortable: false },
  ];
  mounted() {
    this.carregarPaginas();
    this.carregarRevista();
  }
  get idCatalogo() {
    return this.$route.params.idCatalogo;
  }
  get idRevista() {
    return this.$route.params.idRevista;
  }
  async carregarRevista() {
    this.revista = await RevistasService.obterRevista(this.idRevista);
  }
  async carregarPaginas() {
    this.loading = true;
    this.paginas = await RevistasService.listarPaginasDaRevista(this.idRevista);
    if (this.paginas.length > 0) {
      this.pagina = this.paginas[0];
      this.pagina.produtos = await RevistasService.listarProdutosDaPagina(
        this.paginas[0].idPaginaRevista
      );
    }
    this.loading = false;
  }
  async carregarProdutosDaPagina(pagRevista: PaginaRevista) {
    this.loading = true;
    this.pagina.produtos = await RevistasService.listarProdutosDaPagina(
      pagRevista.idPaginaRevista
    );
    this.loading = false;
  }
  @Watch("paginaAtual")
  @Debounce(150)
  onPaginaAtualChange() {
    this.pagina = this.paginas[this.paginaAtual - 1];
    this.carregarProdutosDaPagina(this.pagina);
  }
  async novoItem() {
    const modal = this.$refs.adicionarProduto as AdicionarProdutoPaginaRevista;
    await modal.abrirModal(this.idRevista, this.pagina.idPaginaRevista);
    this.carregarProdutosDaPagina(this.pagina);
  }
  async editarItem(item: ProdutoPaginaRevista) {
    const modal = this.$refs.editarProduto as EditarProdutoPaginaRevista;
    await modal.abrirModal(
      item.idProdutoPaginaRevista,
      this.pagina.idPaginaRevista
    );
    this.carregarProdutosDaPagina(this.pagina);
  }
  async excluirItem(item: ProdutoPaginaRevista) {
    const modalConfirm = this.$refs.confirm as Confirm;
    const title = `Excluir produto ${item.descricao}`;
    const text = `Deseja realmente deletar o produto da revista ${item.descricao} ?`;
    const res = await modalConfirm.open(title, text);
    if (res) {
      this.startLoader();
      await RevistasService.deletarProdutoDaPaginaRevista(item).finally(
        this.stopLoader
      );
      this.carregarProdutosDaPagina(this.pagina);
    }
  }
}
